import { environment } from '../../environments/environment';
import { SQLService } from '../services/sql.service';
import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { PopoverController} from '@ionic/angular';
import { AddressMenuComponent } from './address-menu/address-menu.component';
@Component({
  selector: 'ng-cheques-addresses',
  templateUrl: './addresses.component.html',
  styleUrls: ['./addresses.component.styl']
})
export class AddressesComponent implements OnInit {
  search:string;
  addresses=[];
  count = -1;
  constructor(
    private router: Router,
    public popoverController: PopoverController,
    public sql: SQLService
  ) { 
    this.router.events.subscribe((eve) => {
      if(eve instanceof NavigationEnd) this.get_addresses();
    });
  }
  showing_popover:boolean;lpevent:any;
  _md(e){this.lpevent=e;}
  async popover(item?) {
    if(this.showing_popover)return;
    this.showing_popover=true;
    this.sql.hapticsImpactMedium();
    var popover = await this.popoverController.create({
      component:AddressMenuComponent,
      cssClass: 'popover_container',
      translucent: true,
      componentProps: {enabled: item.enabled},
      event: this.lpevent?this.lpevent:false
    });
    popover.present();
    var { data } = await popover.onWillDismiss();
    if (data && item) {
      this.sql.hapticsImpactLight();
      if(data=='enable')this.enable(item);
      if(data=='disable')this.disable(item);
      if(data=='delete')this.delete_address(item);
    }
    this.showing_popover=false;
    this.lpevent=null;
  }
  filter(e) {
    this.search=e.target.value;
  }
  get_addresses(event?) {
    this.sql.fetch('Addresses',(e)=>{
      if(e)this.addresses=e;
      this.count=e.length;
      setTimeout(()=>{
        if (event) event.target.complete();
      },1234);
    });
  }
  edit_address(a?,i?) {
    this.router.navigate(['folder','Address',a.address_id]);
    if(i)i.closeSlidingItems();
  }
  print_address(a?,i?) {
    this.router.navigate(['folder','Print','Address',a.address_id]);
    if(i)i.closeSlidingItems();
  }
  enable(address){
    this.sql.set('Addresses','address_id',address.address_id,'enabled',1,(res)=>{
      address.enabled = true;
    });
  }
  disable(address){
    this.sql.set('Addresses','address_id',address.address_id,'enabled',0,(res)=>{
      address.enabled = false;
    });
  }
  delete_address(a?,i?) {
    if(confirm(this.sql.word.Delete_Confirmation)) {
      this.sql.delete('Addresses','address_id',a.address_id);
      this.get_addresses();
    } else { if(i)i.closeSlidingItems(); }
  }
  add() {
    this.sql.count('Addresses',(c)=>{
      if(this.sql.Trial && this.sql.Trial_Addresses!=-1 && c>=this.sql.Trial_Addresses) {
        this.sql.show_purhchase_modal();
      } else {this.router.navigate(['folder','Address','New']);}
    });
  }
  end() {this.router.navigate(['folder','Dashboard']);}
  ngOnInit() {
    this.get_addresses();
  }
}